import Vue from 'vue';
/**
 * Base Inner Loader
 * Circular Indeterminate Loader
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.1.6
 */
export default Vue.extend({
    props: {
        size: {
            type: String || Number,
            default: '100',
        },
        width: {
            type: String || Number,
            default: '8',
        },
    },
    render(createElement) {
        return createElement('v-layout', { class: 'align-center column fill-height justify-center' }, [
            createElement('v-flex', { class: 'shrink' }, [
                createElement('v-progress-circular', {
                    props: {
                        color: 'primary',
                        indeterminate: true,
                        size: this.size,
                        width: this.width,
                    },
                }),
            ]),
        ]);
    },
});
